import { render } from "./ModalErrorsMessageImport.vue?vue&type=template&id=c22ea0ee&scoped=true"
import script from "./ModalErrorsMessageImport.vue?vue&type=script&lang=js"
export * from "./ModalErrorsMessageImport.vue?vue&type=script&lang=js"

import "./ModalErrorsMessageImport.vue?vue&type=style&index=0&id=c22ea0ee&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c22ea0ee"]])

export default __exports__